"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDynamicTimeFrame = exports.getCountdown = exports.getTimeInSeconds = exports.getTimeOutStamp = exports.FINAL_TIME_FRAME = exports.INITIAL_TIME_FRAME = exports.LAST_MINUTE_FRAME = void 0;
const MILISECONDS = 1000;
exports.LAST_MINUTE_FRAME = 60000;
exports.INITIAL_TIME_FRAME = 10000;
exports.FINAL_TIME_FRAME = 1000;
const getTimeOutStamp = (expiresIn) => (expiresIn ? Date.now() + expiresIn : null);
exports.getTimeOutStamp = getTimeOutStamp;
const getTimeInSeconds = (value) => Math.ceil(value / MILISECONDS);
exports.getTimeInSeconds = getTimeInSeconds;
const getCountdown = (targetTime) => {
    if (targetTime) {
        const currentTime = Date.now();
        const remainingTimeToExpiration = targetTime - currentTime;
        return (0, exports.getTimeInSeconds)(remainingTimeToExpiration);
    }
    return -1;
};
exports.getCountdown = getCountdown;
const getDynamicTimeFrame = (timeOutStamp) => {
    const targetTime = timeOutStamp ?? 1;
    const currentTime = Date.now();
    const limitTime = targetTime - exports.LAST_MINUTE_FRAME;
    const remainingTimeToWarning = limitTime - currentTime;
    if (remainingTimeToWarning <= exports.LAST_MINUTE_FRAME) {
        return exports.FINAL_TIME_FRAME;
    }
    const frameRatio = Math.floor(remainingTimeToWarning / 2);
    const adaptiveFrame = frameRatio >= exports.LAST_MINUTE_FRAME ? frameRatio : exports.FINAL_TIME_FRAME;
    return Math.max(adaptiveFrame, exports.FINAL_TIME_FRAME);
};
exports.getDynamicTimeFrame = getDynamicTimeFrame;
//# sourceMappingURL=timeOut.helper.js.map